import { BackDropSpinnerProvider } from '@ps-smart-cp/ppfw-client';
import { Outlet } from 'react-router';

function ShellContainer() {
  return (
    <BackDropSpinnerProvider>
      <Outlet />
    </BackDropSpinnerProvider>
  );
}

export { ShellContainer };
